import querystring from 'querystring';
import i18n from 'i18next';

import meta from './meta';

import 'whatwg-fetch';

const META_API_URL = meta('api_url');

let serverUrl;

const setRestApiUrl = url => {
  serverUrl = url;
};

const buildRestApiUrl = (path, params) => {
  let url = `${META_API_URL || serverUrl}${path}`;
  if (url === '/') url = '';

  if (params) return `${url}?${querystring.stringify(params)}`;
  return url;
};

export { buildRestApiUrl, setRestApiUrl };

export default async function(method, path, data, headers) {
  const url = buildRestApiUrl(`/rest${path}`);
  const response = await fetch(url, {
    method,
    headers: {
      ...headers,
      'Content-Type': 'application/json',
      'Accept-Language': i18n.languages[0],
    },
    body: data ? JSON.stringify(data) : undefined,
  });
  return response.json();
}
